import { useTranslation } from 'react-i18next'
import {
  RecentSection,
  RecentLabel,
  RecentList,
  RecentItem,
  RecentNumber,
} from './RecentDestinations.styles'

// Group digits into blocks of four for display (e.g. 081282511007 -> 0812 8251 1007).
const formatDestinationNumber = (value: string) =>
  value.replace(/(.{4})/g, '$1 ').trim()

type RecentDestinationsProps = {
  numbers: string[]
  onSelect: (value: string) => void
}

const RecentDestinations = ({ numbers, onSelect }: RecentDestinationsProps) => {
  const { t } = useTranslation()

  if (numbers.length === 0) return null

  return (
    <RecentSection>
      <RecentLabel>{t('common.recent')}</RecentLabel>
      <RecentList>
        {numbers.map((number) => (
          <RecentItem key={number} type="button" onClick={() => onSelect(number)}>
            <RecentNumber>{formatDestinationNumber(number)}</RecentNumber>
          </RecentItem>
        ))}
      </RecentList>
    </RecentSection>
  )
}

export default RecentDestinations
